module.exports = __webpack_public_path__ + "img/logo.4155ae9d.png";